var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 237,
    height: 204,
    viewBox: "0 0 62.706 53.975",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m60.968 3.3356h-31.266c-0.96004 0-1.7392-0.747-1.7392-1.6678 6.86e-4 -0.92156 0.77986-1.6678 1.7399-1.6678h31.265c0.96004 0 1.7385 0.74624 1.7385 1.6678 0 0.92077-0.77848 1.6678-1.7385 1.6678m0 12.829h-19.696c-0.96073 0-1.7385-0.747-1.7385-1.6678 0-0.92077 0.7778-1.6678 1.7378-1.6678h19.696c0.96073 0 1.7392 0.74703 1.7392 1.6678 0 0.92077-0.77848 1.6678-1.7385 1.6678m-1.0419 12.83h-13.38c-0.96004 0-1.7385-0.747-1.7385-1.6678 0-0.92154 0.77848-1.6678 1.7385-1.6678h13.381c0.96004 0 1.7385 0.74624 1.7385 1.6678 0 0.92077-0.77848 1.6678-1.7385 1.6678m-30.787 16.215c-6.9885 6.6044-17.379 6.1801-23.93-1.2745-6.9465-7.9045-6.9465-20.719 0-28.624 6.9472-7.903 18.21-7.903 25.157 0 6.3407 7.2142 6.8949 18.52 1.6608 26.449l7.17 8.1582a2.1154 2.3861 0 0 1-5e-3 3.3627 2.0851 2.352 0 0 1-2.9544 0.0058zm-0.84726-3.7374c5.8008-6.544 5.8008-17.153 0-23.696-5.8008-6.5439-15.207-6.5439-21.007 0-5.8008 6.5432-5.8008 17.152 0 23.696 5.8008 6.5432 15.207 6.5432 21.007 0z",
    fill: "#aaa",
    fillRule: "evenodd",
    strokeWidth: 0.26458
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.8a458c24d0b29d5d449db353a84402c1.svg";
export { ForwardRef as ReactComponent };